"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersMatchingCriteria = usersMatchingCriteria;
const IAutoAck_1 = require("../models/IAutoAck");
// Mirrors the watcher's query: within a group every criterion must match (AND),
// and a user matches the rule if any group matches (OR).
// See autoAskAcknowledgement.watcher.ts — it builds $or of $and from the same shape.
function matchesCriteria(criteria, user) {
    var _a, _b;
    const values = (_a = criteria.values) !== null && _a !== void 0 ? _a : [];
    switch (criteria.key) {
        case IAutoAck_1.AUTO_ACK_USER_KEY.USER_ID:
            return values.includes(user.id);
        case IAutoAck_1.AUTO_ACK_USER_KEY.DEPARTMENT_ID:
            return !!((_b = user.department) === null || _b === void 0 ? void 0 : _b.id) && values.includes(user.department.id);
        case IAutoAck_1.AUTO_ACK_USER_KEY.TYPE:
            return values.includes(user.type);
        case IAutoAck_1.AUTO_ACK_USER_KEY.FIRST_NAME:
        case IAutoAck_1.AUTO_ACK_USER_KEY.LAST_NAME: {
            const subject = criteria.key === IAutoAck_1.AUTO_ACK_USER_KEY.FIRST_NAME
                ? user.firstName
                : user.lastName;
            return values.some(value => {
                try {
                    return new RegExp(value, "i").test(subject !== null && subject !== void 0 ? subject : "");
                }
                catch (_a) {
                    // A stored pattern that no longer compiles matches nobody rather than
                    // taking the whole screen down.
                    return false;
                }
            });
        }
        default:
            // An unknown key is a server-side field we cannot evaluate; treating it as
            // "matches nobody" under-reports rather than claiming people will be asked.
            return false;
    }
}
function usersMatchingCriteria(groups, users) {
    if (!(groups === null || groups === void 0 ? void 0 : groups.length))
        return [];
    return users.filter(user => groups.some(group => group.length > 0 &&
        group.every(criteria => matchesCriteria(criteria, user))));
}
